import Reveal from "../components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Architectural Audit & Vision",
    text: "We walk your space, listen hard, and map structural reality against ambition. You get a honest scope — not a sales pitch.",
  },
  {
    n: "02",
    title: "Precision 3D & Material Selection",
    text: "Full 3D visualizations, physical material boards, and a fixed investment schedule before a single wall is touched.",
  },
  {
    n: "03",
    title: "Craft Execution",
    text: "Our in-house artisans execute with weekly photographic reports. Dust-controlled, schedule-locked, obsessively detailed.",
  },
  {
    n: "04",
    title: "White-Glove Handover",
    text: "Deep-cleaned, walk-through certified, and backed by a 12-year workmanship warranty in writing.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-copper">The protocol</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tight text-cream sm:text-5xl">
          Renovation, run like an engineering discipline.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08} className="h-full">
            <div
              data-testid={`process-step-${s.n}`}
              className="group flex h-full flex-col gap-6 bg-surface p-8 transition-colors duration-500 hover:bg-elevated"
            >
              <span className="font-mono text-sm text-copper">{s.n}</span>
              <h3 className="font-display text-xl font-semibold tracking-tight text-cream">{s.title}</h3>
              <p className="text-sm leading-relaxed text-cream/60">{s.text}</p>
              <span className="mt-auto h-px w-8 bg-copper transition-all duration-500 group-hover:w-full" />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
